<div class="homeSectionText__cont" [class.see-more]="seeMoreText">
  <div class="homeSectionText__inner">
    <app-ds-typography
      [size]="fontSize.Minor"
      [text]="contentText"
      [color]="fontColor.Secondary">
    </app-ds-typography>
  </div>
  <div class="homeSectionText__button-link">
    <app-ds-button-link
      [type]="buttonLinkType"
      [icon]="!seeMoreText ? icons.ChevronDown : icons.ChevronUp"
      [fontSize]="fontSize.XXXS"
      [iconSize]="14"
      [label]="(!seeMoreText ? 'SEE_MORE' : 'SEE_LESS') | transloco"
      [iconPosition]="iconPosition"
      (clickEvent)="toggleSeeMoreText()">
    </app-ds-button-link>
  </div>
</div>
